import { Routes } from "@angular/router";
import { AnalyticsDashboardComponent } from "./components/analytics-dashboard/analytics-dashboard.component";
import { AnalyticsExecutionComponent } from "./components/analytics-execution/analytics-execution.component";
export const moduleRoutes: Routes = [
    {
        path: '',
        component: AnalyticsDashboardComponent
    },
    {
        path: ':parentId',
        component: AnalyticsExecutionComponent
    }
]